/** The data a report draws from, as staff see it on the report page; editing lives in the settings drawer. */
import { Card, Group, Stack, Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { Report } from '@/api/reports';
import { objectName } from '@/features/objects/objectName';
import { brand } from '@/theme/theme';

export function ReportInputsCard({ report }: { report: Report }) {
  const { t } = useTranslation('reports');
  return (
    <Card className="report-inputs">
      <Stack gap="sm">
        <Text fw={700}>{t('table.inputs')}</Text>
        <Table>
          <Table.Tbody>
            {report.inputs.map((i) => (
              <Table.Tr key={i.role}>
                <Table.Td>{t(`roles.${i.role}`, { defaultValue: i.role })}</Table.Td>
                <Table.Td>
                  <Group gap={6}>
                    <Text fz={14}>{objectName(i.object)}</Text>
                    <Text fz={12} c={brand.textMuted}>
                      {i.object.kind}
                    </Text>
                  </Group>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Stack>
    </Card>
  );
}
